module.exports = __webpack_public_path__ + "img/loading.ec234076.gif";